<script>
export default {
  render() {
    return this.$scopedSlots.default({
      view: this.view,
      switchto: this.switchto,
      ocrEnabled: this.ocrEnabled,
    });
  },
  data() {
    return {
      view: "normal",
    };
  },
  computed: {
    ocrEnabled() {
      return this.$store.state?.settings?.ocr_scan;
    },
  },
  methods: {
    switchto(value) {
      this.view = value;
    },
  },
};
</script>
